/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import Barcode from 'react-barcode';
import numeral from 'numeral';
import {
  Dropdown
} from 'react-bootstrap';
import {
  faTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import utils from '../../../utils/utils.functions';


class ComponentToPrint extends React.Component {

  render() {
    return (
      <div style={{
        position: 'absolute',
        top: 15,
        left: 15,
        width: 960,
        minHeight: 480,
        border: '4px solid #000',
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: 16,
        }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between'
       }}>
				<div>
          <div style={{ width: 125, height: 'auto'}}>
            <img src={this.props.empresa.logo_guia} style={{ width: '100%' }}/>
          </div>
          {this.props.guide.anulado === 1 ?
          <div>
            <div style={{ color: 'red' }}>ESTA GUIA SE ENCUENTRA ANULADA</div>
             <small style={{ color: 'red' }}>Motivo: {this.props.guide.motivo_anulacion}</small>
					</div>
          : null}
				</div>

				<div style={{ width: '100%', textAlign:'right'}}>
          {this.props.extra.emisorVisible && 
            <div>
                <small style={{ fontWeight: 'bold', fontSize: 17 }}>REMITENTE</small>
                <div style={{ fontSize: 28 }}>{this.props.guide.cliente.name.toUpperCase()}</div>
            </div>
          }
					<div>
						<small style={{ fontWeight: 'bold', fontSize: 17 }}>Destinatario</small>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ width: '30%', marginRight: 10, borderRight: '4px solid #000', padding: 5 }}>
              <small>Identificación</small>
						  <div style={{ fontSize: 28 }}>{this.props.guide.cliente_receptor_identificacion}</div>
            </div>
            <div style={{ width: '70%', marginRight: 10, borderRight: '4px solid #000', padding: 5 }}>
              <small>Recibe</small>
						  <div style={{ fontSize: 26 }}>{this.props.guide.cliente_receptor_nombre.toUpperCase()}</div>
            </div>
            <div style={{ width: '30%', paddingTop: 5 }}>
              <small>Telefono</small>
              <div style={{ fontSize: 28 }}>{this.props.guide.cliente_receptor_telefono}</div>
            </div>
            </div>
					</div>
				 </div>
			</div>
		
			<div style={{
        borderTop: '4px solid #000',
        borderBottom: '4px solid #000',
        padding: '13px 0px 13px 0px',
        }} >
					<small style={{ fontWeight: 'bold', fontSize: 17 }}>Dirección de entrega</small>
				  <div style={{ fontSize: 19 }}>{this.props.guide.cliente_receptor_direccion_entrega} - {this.props.guide.estado_guia.estado !== '-' && this.props.guide.estado_guia.estado} {this.props.guide.ciudad_guia.ciudad !== '-' && this.props.guide.ciudad_guia.ciudad} {this.props.guide.pais_guia.country} </div>
			</div>

      <div style={{
        borderBottom: '4px solid #000',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        }} >
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column', borderRight: '4px solid #000', height: 100 }}>
            <small>Guia de envio</small>
            <h1 style={{ margin: 0, padding: 0, fontSize: 45 }}>{`${this.props.showPrefixGuide ? this.props.guide.master_guia.rel_tipos.prefijo : this.props.prefijo}-${this.props.guide.guia_paquete}`}</h1>
          </div>
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column',  height: 100 }}>
            <small>Tipo de envio</small>
            <h1 style={{ margin: 0, padding: 0, fontSize: 45 }}>{this.props.guide.master_guia.rel_tipos.description}</h1>
          </div>
			</div>

			<div style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        }}>
					<div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}>
				  	<div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column', borderRight: '4px solid #000', height: 100}}>
							<small style={{ fontWeight: 'bold', fontSize: 17 }}>Bultos</small>
							<div style={{ fontSize: 30 }}>
                {this.props.guide.bultos.length}
              </div>
						</div>
            <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column', borderRight: '4px solid #000', height: 100}}>
							<small style={{ fontWeight: 'bold', fontSize: 17 }}>Peso total</small>
							<div style={{ fontSize: 26 }}>{this.props.peso} KG</div>
						</div>
            <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column', borderRight: '4px solid #000', height: 100}}>
							<small style={{ fontWeight: 'bold', fontSize: 17 }}>Ft3</small>
							<div style={{ fontSize: 26 }}>{this.props.pie}</div>
						</div>
            <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'column', height: 100}}>
              <small style={{ fontWeight: 'bold', fontSize: 17 }}>Registrado</small>
						<div style={{ fontSize: 19 }}>{moment(this.props.guide.createdAt).format('DD/MM/YYYY')}</div>
						</div>
					</div>
			</div>

			<div style={{fontSize: 10, textAlign: 'center'}}>
				<div>
						{this.props.empresa.nombre_empresa}
				</div>
				<div>
						{this.props.empresa.correo_soporte}
				</div>
			</div>

      <div style={{ textAlign: 'center', marginTop: 5 }}>
        <Barcode value={this.props.guide.uuid} height={25} width={1} margin={0} />
      </div>
    </div>
    );
  }
}
 
const PrinterGuide = ({ data, prefijo, empresa, disabled, showPrefixGuide }) => {

  const extras = {
    emisorVisible: utils.configExtra(empresa.operaciones, 'SHOW_EMISOR_GUIDE'),
  };

  const [peso, setPeso] = useState(0);
  const [pie, setPie] = useState(0);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const calculatePeso = () => {
    let peso_total = 0;
    let pie_total = 0;
    data.bultos.map((e) => {
      peso_total += parseFloat(e.peso);
      pie_total += parseFloat(e.pie);
    })

    let fPeso = numeral(peso_total).format('0.00')
    let fPie = numeral(pie_total).format('0.00')

    setPeso(fPeso);
    setPie(fPie);
  }

  useEffect(() => {
    calculatePeso()
  },[])

  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint 
          guide={data}
          empresa={empresa}
          prefijo={prefijo}
          peso={peso}
          pie={pie}
          ref={componentRef}
          extra={extras}
          showPrefixGuide={showPrefixGuide}
        />
      </div>
      <Dropdown.Item disabled={disabled} onClick={handlePrint}>
        <FontAwesomeIcon icon={faTag} /> Imprimir guia
      </Dropdown.Item>
    </div>
  );
};

export default PrinterGuide;